export const INTERNATIONAL_PHONE_NUMBER_EXAMPLE = "+33123456789";
export const INTERNATIONAL_PHONE_NUMBER_ERROR = "Phone number must be in international format (e.g. +33123456789)";

const INTERNATIONAL_PHONE_NUMBER_REGEX = /^\+[1-9]\d{7,14}$/;
const PHONE_NUMBER_SEPARATOR_REGEX = /[\s\-().]/g;

export function normalizeInternationalPhoneNumber(value: string): string {
  return value.trim().replace(PHONE_NUMBER_SEPARATOR_REGEX, "");
}

export function normalizeOptionalInternationalPhoneNumber(value: string | null | undefined): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return null;
  }

  return normalizeInternationalPhoneNumber(trimmed);
}

export function isValidInternationalPhoneNumber(value: string | null | undefined): boolean {
  const normalized = normalizeOptionalInternationalPhoneNumber(value);
  if (!normalized) {
    return false;
  }

  return INTERNATIONAL_PHONE_NUMBER_REGEX.test(normalized);
}

export function parseOptionalInternationalPhoneNumber(
  value: string | null | undefined,
): { success: true; value: string | null } | { success: false; error: string } {
  const normalized = normalizeOptionalInternationalPhoneNumber(value);

  if (normalized === null) {
    return { success: true, value: null };
  }

  if (!INTERNATIONAL_PHONE_NUMBER_REGEX.test(normalized)) {
    return { success: false, error: INTERNATIONAL_PHONE_NUMBER_ERROR };
  }

  return { success: true, value: normalized };
}
